export default __webpack_public_path__ + "static/CustomizableUI-7ccca682243d789ae9f7f94e27d0aa0b.png";